module.exports = "<div class=\"boolean-mark\">\n  <i [class]=\"value ? 'fa fa-check' : 'fa fa-times'\"></i>\n</div>\n"